import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginMultiRoleComponent } from './modules/login-page/login-multi-role/login-multi-role.component';
import { AuthService } from './core/auth/auth.service';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _authService: AuthService,
            private _router: Router){}

  canActivate(): boolean{
    if(this._authService.loggedIn()){
      return true
    }else{
      this._router.navigate(['/login'])
      return false
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/auth.guard.ts